module.exports = __webpack_public_path__ + "assets/1db65a660dd9a3134f81c2b391cd43f3.mp4";